/**
 * Модуль для работы со страницей записи к врачу
 * Обрабатывает выбранные дату и время из списка врачей
 */

(function($) {
    'use strict';

    /**
     * Инициализация обработки выбранных даты и времени
     */
    function initAppointmentSelection() {
        const selectedDoctorId = localStorage.getItem('selectedDoctorId');
        const selectedDate = localStorage.getItem('selectedDate');
        const selectedTime = localStorage.getItem('selectedTime');
        const currentDoctorId = window.currentDoctorId;

        // Получаем дату и время из URL параметров (если страница с выбранным продуктом)
        const urlParams = new URLSearchParams(window.location.search);
        const urlDate = urlParams.get('date');
        const urlTime = urlParams.get('time');

        if (window.isProductPage) {
            // Если открыта страница с выбранным продуктом
            handleProductPageSelection(selectedDoctorId, selectedDate, selectedTime, currentDoctorId, urlDate, urlTime);
        } else {
            // Если открыта страница выбора продукта
            handleProductSelectionPage(selectedDoctorId, selectedDate, selectedTime, currentDoctorId);
        }
    }

    /**
     * Обработка страницы с выбранным продуктом
     */
    function handleProductPageSelection(selectedDoctorId, selectedDate, selectedTime, currentDoctorId, urlDate, urlTime) {
        // Проверяем сначала URL параметры, если их нет - берем из localStorage
        const finalDate = urlDate || (selectedDoctorId == currentDoctorId ? selectedDate : null);
        const finalTime = urlTime || (selectedDoctorId == currentDoctorId ? selectedTime : null);

        if (finalDate && finalTime) {
            // Показываем уведомление о выбранном времени
            showSelectedTimeNotice(finalDate, finalTime);

            // Автоматически загружаем доступные дни и выбираем время
            loadAndSelectTime(finalDate, finalTime);
        }
    }

    /**
     * Обработка страницы выбора продукта
     */
    function handleProductSelectionPage(selectedDoctorId, selectedDate, selectedTime, currentDoctorId) {
        // Сравниваем как строки, чтобы избежать проблем с типами
        if (selectedDoctorId == currentDoctorId && selectedDate && selectedTime) {
            // Добавляем параметры к ссылкам на продукты
            addParametersToProductLinks(selectedDate, selectedTime);

            // Показываем уведомление о выбранном времени
            showProductSelectionNotice(selectedDate, selectedTime);
        }
    }

    /**
     * Показывает уведомление о выбранном времени на странице продукта
     */
    function showSelectedTimeNotice(date, time) {
        const $notice = $('<section class="selected-time-section">' +
            '<div class="selected-time-notice">' +
                '<strong>Вы выбрали:</strong> ' + date + ' в ' + time + '. Подтвердите запись ниже.' +
            '</div>' +
            '</section>');
        $('.selected-product-section').after($notice);
    }

    /**
     * Показывает уведомление о выбранном времени на странице выбора продукта
     */
    function showProductSelectionNotice(date, time) {
        const $notice = $('<div class="selected-time-notice" style="background: #FFF9E6; border: 1px solid #F4C210; border-radius: 8px; padding: 16px; margin-bottom: 20px;">' +
            '<strong>Вы выбрали:</strong> ' + date + ' в ' + time +
            '</div>');
        $('.products-section').prepend($notice);
    }

    /**
     * Добавляет параметры даты и времени к ссылкам на продукты
     */
    function addParametersToProductLinks(date, time) {
        $('.product-link').each(function() {
            const $link = $(this);
            const href = $link.attr('href');
            const separator = href.includes('?') ? '&' : '?';
            const newHref = `${href}${separator}date=${encodeURIComponent(date)}&time=${encodeURIComponent(time)}`;
            $link.attr('href', newHref);
        });
    }

    /**
     * Загружает доступные дни и автоматически выбирает нужное время
     */
    function loadAndSelectTime(finalDate, finalTime) {
        const doctorId = window.currentDoctorId;

        $.ajax({
            type: 'POST',
            url: '/api/booking/get-days',
            data: {
                'doctorId': doctorId,
                'html': false,
            },
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function(response) {
                if (response.status === 'success' && response.data.length > 0) {
                    // Ищем нужную дату среди доступных дней
                    const targetDay = response.data.find(day => day.date === finalDate);

                    if (targetDay) {
                        // Имитируем клик по нужной ячейке календаря
                        selectDateInCalendar(finalDate);

                        // Ждем загрузки слотов и выбираем нужный временной слот
                        setTimeout(function() {
                            selectTimeSlot(finalTime, finalDate);
                        }, 1000);
                    }
                }
            },
            error: function(xhr, status, error) {
                // Тихо обрабатываем ошибку
                console.log('Ошибка загрузки дней:', error);
            }
        });
    }

    /**
     * Выбирает дату в календаре
     */
    function selectDateInCalendar(finalDate) {
        setTimeout(function() {
            const dateParts = finalDate.split('.');
            const dayNumber = parseInt(dateParts[0]);
            
            // Находим все ячейки дней в календаре
            const $allDayCells = $('.air-datepicker-cell.-day-:not(.-disabled-)');
            
            // Ищем нужную ячейку
            $allDayCells.each(function() {
                const $cell = $(this);
                const cellText = $cell.text().trim();
                
                // Проверяем, что это нужный день и не другой месяц
                if (cellText === dayNumber.toString() && !$cell.hasClass('-other-month-')) {
                    // Имитируем клик по ячейке
                    $cell.trigger('click');
                    return false; // Прерываем цикл
                }
            });
        }, 500);
    }

    /**
     * Выбирает временной слот
     */
    function selectTimeSlot(finalTime, finalDate) {
        const $targetSlot = $('.table__cell[data-time="' + finalTime + '"]');
        
        if ($targetSlot.length > 0) {
            $targetSlot.addClass('active');
            $('#appoint__button').attr('data-time', finalTime);
            $('#appoint__button').prop('disabled', false);
            $('.appoint__comment').show();
            $('.appoint__form').show();

            // Устанавливаем глобальные переменные даты и времени для отправки формы
            window.selectedTime = finalTime;
            window.selectedDate = finalDate;

            // Также устанавливаем локальную переменную selectedTime, если она доступна
            if (typeof selectedTime !== 'undefined') {
                selectedTime = finalTime;
            }

            // Устанавливаем значения в поля формы
            $('#appoint__time').val(finalTime);
            $('#datepicker').data('selected-date', finalDate);
            
            // НЕ очищаем localStorage здесь!
            // Он очистится либо при ручном выборе другой даты (в app.js),
            // либо после успешной записи (в custom.js)
        }
    }

    // Инициализация при загрузке страницы
    $(document).ready(function() {
        // Проверяем, находимся ли мы на странице записи к врачу
        if ($('.doc-timetable__container').length > 0) {
            initAppointmentSelection();
        }
    });

})(window.jQuery || window.$ || jQuery);
